/*******************************************************************************
 * File: Header.js
 * Summary: Demo website header (across all pages)
 ******************************************************************************/

/*******************************************************************************
 * Section: Imports
 ******************************************************************************/
import styled from 'styled-components'

import { QR } from '../../styled/CommonStylesForms'
import '../../assets/css/app.css'
import { useState } from 'react'
import { ReactComponent as VisibilityOn } from '../../assets/icon/visibility_on.svg'
import { ReactComponent as VisibilityOff } from '../../assets/icon/visibility_off.svg'

/*******************************************************************************
 * Section: Custom Divs
 ******************************************************************************/

const HeaderButton = styled.button`
  // Figma
  font-weight: 600;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;

  // Custom
  background-color: transparent;
  color: #ffffff;
  padding: 0px 30px;
  border: solid;
  border-width: 1px;
  border-radius: 14px;
  height: 27px;
  :hover {
    cursor: pointer;
  }
`

const LoginButton = styled.button`
  width: 100%;
  border: 1px solid #4c3de3;
  background-color: transparent;
  color: #4c3de3;
  padding: 12px;
  border-radius: 17.5px;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  margin: 10px 0;
`

const PasswordInputContainer = styled.div`
  position: relative;
  width: 100%;
`

const PasswordToggleIcon = styled.span`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  user-select: none;

  svg {
    fill: #a0a0a0;
    width: 20px;
    height: 20px;
  }
`

const ForgotPasswordLink = styled.a`
  color: #4c3de3 !important;
  text-decoration: underline;
  background: none;
  border: none;
  cursor: pointer;
  font: inherit;
`

/*******************************************************************************
 * Function: LoggedInAccountHeader:
 * Summary: Account portion of the Header. Displays an icon along with the users
 *          name beside the users icon
 ******************************************************************************/
function LoggedOutAccountHeader(props) {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <>
      <HeaderButton onClick={props.startNewAccount}>Join</HeaderButton>
      <HeaderButton
        onClick={() => {
          const willOpen = !props.showLoginModal
          props.setConnectionPurpose('login')
          if (willOpen && props.refreshInvitation) {
            props.refreshInvitation()
          }
          props.setShowLoginModal(willOpen)
        }}
      >
        Log In
      </HeaderButton>

      {props.showLoginModal && (
        <div className="dialog-login">
          {!props.loader ? (
            <>
              <h3 className="text-tetriary text-center">Log into SITA Air</h3>
              <div className="input-holder">
                <input
                  className="single-line"
                  type="text"
                  placeholder="SITA Air ID or Username"
                ></input>
              </div>
              <div className="input-holder">
                <PasswordInputContainer>
                  <input
                    className="single-line password"
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Password"
                  ></input>
                  <PasswordToggleIcon
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <VisibilityOff /> : <VisibilityOn />}
                  </PasswordToggleIcon>
                </PasswordInputContainer>
              </div>
              <input type="checkbox" /> Remember Me
              <LoginButton>LOG IN</LoginButton>
              <p>
                <ForgotPasswordLink href="#">
                  Forgot password
                </ForgotPasswordLink>
              </p>
              <div className="qr-holder">
                <h3 className="text-primary">
                  Log in with a<br />
                  SITA Air ID
                </h3>
                <QR
                  value={
                    props.invitation ? props.invitation.invitation_url : ''
                  }
                  size={260}
                  renderAs="svg"
                />
                <p>
                  Scan the above QR code
                  <br />
                  with your app.
                </p>
              </div>
            </>
          ) : (
            <div className="loader-wrapper">
              <div className="loader"></div>
              <h3 className="text-secondary text-bold">Please wait...</h3>
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default LoggedOutAccountHeader
